@if (loading$ | async) {
  <div class="loader-overlay">
    <div class="loader"></div>
  </div>
}
